export default "__VITE_ASSET__BNMMGmKC__"